import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export const constantRoutes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: () => import('../components/page/Login.vue'),
        meta: {
            title: '登录',
            requireAuth: true
        }
    },
    {
        path: '/404',
        component: () => import('../components/page/404'),
        hidden: true
    },
]

const createRouter = () => new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})
const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
// export default new Router({
//     routes: [
//         {
//             path: '/',
//             redirect: '/1090000000000000000001'
//         },
//         {
//             path: '/',
//             component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
//             meta: { title: '自述文件' },
//             children: [
//                 {
//                     path: '/1090000000000000000001',
//                     component: () => import('../components/page/PatientList.vue'),
//                     meta: { title: '患者管理' }
//                 },
//                 {
//                     path: '/1090000000000000000003',
//                     component: () => import('../components/page/SeeDoctor.vue'),
//                     meta: { title: '看病就诊' }
//                 },
//                 {
//                     path: '/MenuList',
//                     component: () => import('../components/page/MenuList.vue'),
//                     meta: { title: '菜单设置' }
//                 },
//                 {
//                     path: '/myPrescribe',
//                     component: () => import('../components/page/myPrescribe.vue'),
//                     meta: { title: '自备良方' }
//                 },
//                 {
//                     path: '/1090000000000000000004',
//                     component: () => import('../components/page/Parties.vue'),
//                     meta: { title: '协定方' }
//                 },
//                 {
//                     path: '/1090000000000000000005',
//                     component: () => import('../components/page/Charge.vue'),
//                     meta: { title: '共享药房管理' }
//                 },
//                 {
//                     path: '/1090000000000000000007',
//                     component: () => import('../components/page/MaintenanceIngredients.vue'),
//                     meta: { title: '药材维护' }
//                 },
//                 {
//                     path: '/1090000000000000000008',
//                     component: () => import('../components/page/BaseForm.vue'),
//                     meta: { title: '药品单位' }
//                 },
//                 {
//                     path: '/supplierSet',
//                     component: () => import('../components/page/SupplierSet'),
//                     meta: { title: '药房信息' }
//                 },
//                 {
//                     path: '/productCategory',
//                     component: () => import('../components/page/productCategory'),
//                     meta: { title: '产品类别' }
//                 },
//                 {
//                     path: '/1090000000000000000012',
//                     component: () => import('../components/page/StaffSet.vue'),
//                     meta: { title: '员工设置' }
//                 },
//                 {
//                     path: '/1090000000000000000013',
//                     component: () => import('../components/page/BaseCharts.vue'),
//                     meta: { title: '角色设置' }
//                 },
//                 {
//                     path: '/permissionSet',
//                     component: () => import('../components/page/permissionSet.vue'),
//                     meta: { title: '权限设置' }
//                 },
//                 {
//                     path: '/agentList',
//                     component: () => import('../components/page/AgentList.vue'),
//                     meta: { title: '代理商列表' }
//                 },
//                 {
//                     path: '/clinicData',
//                     component: () => import('../components/page/ClinicData.vue'),
//                     meta: { title: '药房基础配置' }
//                 },
//                 {
//                     path: '/hospitalSet',
//                     component: () => import('../components/page/HospitalSet.vue'),
//                     meta: { title: '诊所管理' }
//                 },
//                 {
//                     path: '/clinicPharmacy',
//                     component: () => import('../components/page/ClinicPharmacy.vue'),
//                     meta: { title: '诊所药房列表' }
//                 },
//                 {
//                     path: '/performanceStatistics',
//                     component: () => import('../components/page/PerformanceStatistics'),
//                     meta: { title: '业绩统计' }
//                 },
//                 {
//                     path: '/commonDiagnose',
//                     component: () => import('../components/page/CommonDiagnose.vue'),
//                     meta: { title: '常见诊断' }
//                 },
//                 {
//                     path: '/commonMalady',
//                     component: () => import('../components/page/CommonMalady.vue'),
//                     meta: { title: '常见症状' }
//                 },
//                 {
//                     path: '/subjectSet',
//                     component: () => import('../components/page/SubjectSet.vue'),
//                     meta: { title: '科室设置' }
//                 },
//                 {
//                     path: '/medicinesDosage',
//                     component: () => import('../components/page/MedicinesDosage.vue'),
//                     meta: { title: '药品剂型' }
//                 },
//                 {
//                     path: '/outpatientStatistics',
//                     component: () => import('../components/page/OutpatientStatistics.vue'),
//                     meta: { title: '门诊统计' }
//                 },
//                 {
//                     path: '/doctorVisitsStatistics',
//                     component: () => import('../components/page/DoctorVisitsStatistics.vue'),
//                     meta: { title: '医生接诊统计' }
//                 },
//                 {
//                     path: '/prescriptionAll',
//                     component: () => import('../components/page/PrescribeAll.vue'),
//                     meta: { title: '处方列表' }
//                 },
//                 {
//                     path: '/courseList',
//                     component: () => import('../components/page/CourseList.vue'),
//                     meta: { title: '科目列表' }
//                 },
//                 {
//                     path: '/HistoryPrescription',
//                     component: () => import('../components/page/HistoryPrescription.vue'),
//                     meta: { title: '历史处方' }
//                 },
//                 {
//                     path: '/dashboard',
//                     component: () => import('../components/page/Dashboard.vue'),
//                     meta: { title: '系统首页' }
//                 },
//                 {
//                     path: '/i18n',
//                     component: () => import('../components/page/I18n.vue'),
//                     meta: { title: '国际化' }
//                 },
//                 {
//                     path: '/permission',
//                     component: () => import('../components/page/Permission.vue'),
//                     meta: { title: '权限测试', permission: true }
//                 },
//                 {
//                     path: '/donate',
//                     component: () => import('../components/page/Donate.vue'),
//                     meta: { title: '支持作者' }
//                 }
//             ]
//         },
//         {
//             path: '/login',
//             component: () => import('@/components/page/Login.vue'),
//             meta: { title: '登录' }
//         },
//         {
//             path: '/insert',
//             component: () => import('../components/page/insert.vue'),
//             meta: { title: '注册' }
//         },
//         {
//             path: '*',
//             redirect: '/404'
//         }
//     ]
// });
